
<script>
    import { createEventDispatcher } from 'svelte';
    import { breakpoint } from '../componentes/MediaQuery.svelte';
    import { postData } from '../scripts';
    import { urlapi } from '../stores/store';
    
    export let cliente={};
    export let factura={};
    let campoNIT=false;

    const dispatch = createEventDispatcher();

    let consumidorFinal=function() {
        cliente.nit='CF';
        cliente.nombre='CONSUMIDOR FINAL';
        cliente.direccion='GUATEMALA, CIUDAD';
        validate()
    }

    let limpiar=function() {
        cliente.nit='';
        cliente.nombre='';
        cliente.direccion='';
        campoNIT.focus()
    }

    function validate() {
		cliente.activo=false;
		dispatch('validate', {});
	}
    let editar=function() {
        cliente.activo=true;
    }

/*    postData($urlapi, [{'cmd':'facturas_verifyNIT','nit':'36600792'}]) //36600792 //65856686
    .then(data => {
        if(data[0].result!==false)
        {
            cliente.nit=data[0].result.nit;
            cliente.nombre=data[0].result.nombre;
            cliente.direccion=data[0].result.direccion;
            cliente.tipo_cliente=data[0].result.tipo_cliente;
            cliente.activo=false;
            console.table( cliente )
        }
    });*/

    //consumidorFinal()

    let timer=null;

    function Enter(e,campo)
    {
        let charCode = (e.which) ? e.which : e.keyCode
        if(timer!==null) clearTimeout(timer);
        timer=setTimeout(function() { buscarNIT() },500)
        if(charCode == 13){ buscarNIT() }
        return true;
    }

    function buscarNIT()
    {
        if(cliente.nit!=='')
        {
            postData($urlapi, [{'cmd':'facturas_verifyNIT','nit':cliente.nit}])
            .then(data => {
                if(data[0].result!==false)
                {
                    cliente.nit=data[0].result.nit;
                    cliente.nombre=data[0].result.nombre;
                    cliente.direccion=data[0].result.direccion;
                    cliente.tipo_cliente=data[0].result.tipo_cliente;
                    cliente.activo=false;
                    dispatch('validate', {});
                }
            });
        }
    }

</script>


<div class="card mt-2 mb-2" >

    {#if cliente.activo===true}
        <div class="card-header">
            DATOS DEL CLIENTE
        </div>    
        <form on:submit|preventDefault={validate}>
            <ul class="list-group list-group-flush">
                <li class="list-group-item">
                        <div class="form-floating">
                            <!-- svelte-ignore a11y-autofocus -->
                            <input on:keydown={Enter} type="text" class="form-control form-control-sm" id="floatnit" placeholder="NIT" bind:value={cliente.nit} bind:this={campoNIT} autofocus required>
                            <label for="floatnit" class='text-secondary'>NIT</label>
                        </div>          
                </li>
                <li class="list-group-item">
                        <div class="form-floating">
                            <input type="text" class="form-control form-control-sm" id="floatnombre" placeholder="NOMBRE" bind:value={cliente.nombre} required>
                            <label for="floatnombre" class='text-secondary'>NOMBRE</label>
                        </div>
                </li>
                <li class="list-group-item">
                        <div class="form-floating">
                            <input type="text" class="form-control form-control-sm" id="floatdireccion" placeholder="DIRECCIÓN" bind:value={cliente.direccion} required>
                            <label for="floatdireccion" class='text-secondary'>DIRECCIÓN</label>
                        </div>
                </li>
                <li class="list-group-item">
                        <button type="submit" 
                            class:btn-lg={$breakpoint === 'xxl'}
                            class:btn-sm={$breakpoint !== 'xxl'}
                            class='btn btn-success me-3'><i class="bi bi-caret-up-fill"></i>
                        </button>
                        <button type="submit"
                            class:btn-lg={$breakpoint === 'xxl'}
                            class:btn-sm={$breakpoint !== 'xxl'}                        
                            on:click={consumidorFinal} class='btn btn-primary me-3 '><i class="bi bi-box-arrow-in-right me-1"></i>CF
                        </button>
                        <div class="float-end mt-1">
                            <button type="button"
                                class:btn-lg={$breakpoint === 'xxl'}
                                class:btn-sm={$breakpoint !== 'xxl'}                            
                                on:click={limpiar} class='btn btn-danger me-1'><i class="bi bi-trash me-1"></i>LIMPIAR
                            </button>
                        </div>
                </li>
            </ul>
        </form>
    {:else}
        <div class="card-header">
            <button type="button" disabled={factura.pagado}
                class:btn-lg={$breakpoint === 'xxl'}
                class:btn-sm={$breakpoint !== 'xxl'}            
                on:click={editar} class='btn btn-warning float-end'><i class="bi bi-caret-down-fill"></i>
            </button>
            <div class='row'>
                <div class="col-3"><p class='mb-1 lh-1 text-primary'><small class='text-muted'>NIT:</small><br/><strong>{cliente.nit}</strong></p></div>
                <div class="col-6"><p class='mb-1 lh-1 text-primary'><small class='text-muted'>NOMBRE:</small><br/><strong>{cliente.nombre}</strong></p></div>
                <div class="col-12"><p class='mb-1 lh-1 text-primary'><small class='text-muted'>DIRECCIÓN:</small><br/><strong>{cliente.direccion}</strong></p></div>
            </div>
        </div>
    {/if}

</div>




                                